import { render } from "./Notice.vue?vue&type=template&id=a0abeba2&scoped=true"
import script from "./Notice.vue?vue&type=script&lang=js"
export * from "./Notice.vue?vue&type=script&lang=js"

import "./Notice.vue?vue&type=style&index=0&id=a0abeba2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a0abeba2"

export default script